import React, { useState, useEffect } from "react";
import "../../App.css";
import "./css/memoryQuiz.css";
import { questions } from "./memoryQuizQuestions";

const successMessages = [
  "Good job bb! 💕",
  "Wow!! ♥️"
];

const endScreenGifs = {
  perfect: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZjVtY3E1cGkwc3NjYWlwZnJnOGg0NWc0ZXh5Ymw5eG5zbnZzcjNucSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/N6funLtVsHW0g/giphy.gif", // Celebration/happy couple
  great: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNXcxejAzMjN1ZnlsdjcxN2ZxcDlhenljZXdiaHRneHF4YXR4MGNrcSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/TjSPQgowhhJdHgvnwA/giphy.gif", // Jumping Cat
  okay: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNmx6aDZ4bmgwZTg3bmpxajAza3N1bzU5NDdveGE5MzF2d3R3OHhmNyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/TZBED1pP5m8N2/giphy.gif" // Cute thumbs up
};

const FloatingHearts = () => {
  const hearts = Array.from({ length: 100 }).map((_, i) => (
    <div key={i} className="floating-heart" />
  ));
  return <div className="hearts-container">{hearts}</div>;
};

const Confetti = () => {
  const pieces = Array.from({ length: 20 }).map((_, i) => (
    <div key={i} className="confetti-piece" />
  ));
  return <div className="confetti-container">{pieces}</div>;
};

function MemoryQuiz() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const [quizStarted, setQuizStarted] = useState(false);
  const [quizFinished, setQuizFinished] = useState(false);
  const [showHearts, setShowHearts] = useState(false);
  // const [showConfetti, setShowConfetti] = useState(false);
  const [randomMessage, setRandomMessage] = useState("");

  useEffect(() => {
    console.log("MemoryQuiz component mounted");
  }, []);

  const playSound = (type) => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    if (type === "correct") {
      oscillator.frequency.value = 800;
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.2);
    } else {
      oscillator.frequency.value = 400;
      gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.15);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.15);
    }
  };

  const triggerHaptics = () => {
    if (navigator.vibrate) {
      navigator.vibrate(100);
    }
  };

  const startQuiz = () => {
    setQuizStarted(true);
  };

  const handleAnswerClick = (index) => {
    if (showFeedback) return;

    setSelectedIndex(index);
    setShowFeedback(true);

    const isCorrect = index === questions[currentQuestion].correctIndex;

    if (isCorrect) {
      setScore(score + 1);
      playSound("correct");
      triggerHaptics();
      setShowHearts(true);
      // setShowConfetti(true);
      setRandomMessage(successMessages[Math.floor(Math.random() * successMessages.length)]);
    } else {
      playSound("wrong");
    }

    const delayTime = isCorrect ? 1900 : 1800;

    setTimeout(() => {
      setShowHearts(false);
      // setShowConfetti(false);
      const nextQuestion = currentQuestion + 1;

      if (nextQuestion < questions.length) {
        setCurrentQuestion(nextQuestion);
        setSelectedIndex(null);
        setShowFeedback(false);
        setRandomMessage("");
      } else {
        setQuizFinished(true);
      }
    }, delayTime);
  };

  const restartQuiz = () => {
    setCurrentQuestion(0);
    setScore(0);
    setSelectedIndex(null);
    setShowFeedback(false);
    setQuizFinished(false);
    setShowHearts(false);
    // setShowConfetti(false);
    setRandomMessage("");
    setQuizStarted(true);
  };

  // Start Screen
  if (!quizStarted) {
    return (
      <div className="memoryQuiz_wrapper">
        <div className="memoryQuiz_app">
          <div className="memoryQuiz_card start-card">
            <div className="floating-emoji">💕</div>
            <h1 className="start-title">Year 3 Memory Quiz</h1>
            <p className="start-subtitle">How well do you remember what happened in Year 3?</p> 
            <p className="start-description">
              Get a passing score (70%+) and I'll pay for your next set of nails 💅
            </p>
            <button className="memoryQuiz_start-btn" onClick={startQuiz}>
              Start Quiz 🫣
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Quiz Finished Screen
  if (quizFinished) {
    const percentage = Math.round((score / questions.length) * 100);
    let celebrationEmoji = "💕";
    let gifUrl = endScreenGifs.okay;
    
    if (percentage === 100) {
      celebrationEmoji = "👑";
      gifUrl = endScreenGifs.perfect;
    } else if (percentage >= 70) {
      celebrationEmoji = "🌟";
      gifUrl = endScreenGifs.great;
    }

    return (
      <div className="memoryQuiz_wrapper">
        <div className="memoryQuiz_app">
          {percentage === 100 && <Confetti />}
          <div className="memoryQuiz_card final-card">
            <h1 className="final-title">{celebrationEmoji} Quiz Complete {celebrationEmoji}</h1>
            <div className="gif-container">
              <img src={gifUrl} alt="celebration" className="end-gif" />
            </div>
            <h2 className="final-score">
              You got {score} out of {questions.length} correct!
            </h2>
            <p className="final-percentage">{percentage}%</p>
            <p className="final-message">
              {
                percentage === 100
                  ? "Damn you really got 100%??? I didn't think you were this smart... Good job bb!! So proud of you 😛"
                  : percentage >= 70
                    ? "Damn I guess I gotta get buy you a set of nails of now... 💅"
                    : "Wtf you got so low?? Better luck next time, if you want another chance you know what to do..."
              }
            </p>
            <button className="memoryQuiz_restart-btn" onClick={restartQuiz}>
              Play Again 🔄
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Quiz Screen
  const question = questions[currentQuestion];

  return (
    <div className="memoryQuiz_wrapper">
      {showHearts && <FloatingHearts />}
      <div className="memoryQuiz_app">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${((currentQuestion + 1) / questions.length) * 100}%` }}
          />
        </div>

        <div className="score-display">
          Score: {score}/{questions.length} 💕
        </div>

        <div className="memoryQuiz_card">
          <p className="question-counter">
            Question {currentQuestion + 1} of {questions.length}
          </p>
          <h2 className="memoryQuiz_question">{question.question}</h2>
        </div>

        <div className="memoryQuiz_answers-grid">
          {question.options.map((option, index) => {
            let btnClass = "memoryQuiz_answer-btn";

            if (showFeedback) {
              if (index === question.correctIndex) {
                btnClass = `${btnClass} correct`;
              } else if (index === selectedIndex) {
                btnClass = `${btnClass} wrong`;
              }
            }

            return (
              <button
                key={index}
                className={btnClass}
                onClick={() => handleAnswerClick(index)}
                disabled={showFeedback}
              >
                {option}
              </button>
            );
          })}
        </div>

        <div className="memoryQuiz_feedback-container">
          {showFeedback && (
            <div className="memoryQuiz_feedback">
              {selectedIndex === question.correctIndex ? (
                <>
                  <p className="feedback-text">🤓 Correct!</p>
                  <p className="success-message">{randomMessage}</p>
                </>
              ) : (
                <p className="feedback-text">💔 WTF??</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemoryQuiz;